import React from "react"
import "fontsource-noto-serif-jp"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import "../styles/reboot.scss"
import "../styles/style.scss"

import Header from "./header"
import Footer from "./footer"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <div id="container">
        <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
        <main>{children}</main>
        <Footer siteTitle={data.site.siteMetadata?.title || `Title`} />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
